module.exports = __webpack_public_path__ + "static/media/eye.1849009c.svg";